import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchCfs'
})
export class SearchCfsPipe implements PipeTransform {

  transform(cfs: any, searchText: string){
    
    if (!searchText) {
      return cfs; // Return the original array if search text is empty
    }
  
    searchText = searchText.toLowerCase(); // Convert the search text to lowercase for case-insensitive comparison
  
    return cfs.filter((cfs: any) => cfs.name.toLowerCase().includes(searchText));
  }

}
